import { Card, CardBody } from "react-bootstrap";
import { isEmpty } from "../../helpers";
import { LoyaltyLevelModel } from "../../models";
import { useLoyalty } from "../../context";
import { CheckCircleFill } from "react-bootstrap-icons";
import { useStore } from "../../hooks";

const LoyaltyLevelCard = () => {
  const { loyaltyLevels } = useStore();
  const { currentLevel, loyaltyPoints } = useLoyalty();
  const getBenefitType = (item: LoyaltyLevelModel) =>
    item.level_benefit_type === "product"
      ? "Free Food"
      : `$${item.level_benefit} Off`;

  if (isEmpty(loyaltyLevels)) return <></>;

  const isActive = (key: number) => key < Number(currentLevel);
  const isCurrent = (key: number) => key === Number(currentLevel);

  return (
    <>
      <div className="loyalty_sec">
        <Card>
          <CardBody className="py-4">
            <div className="reward_level_head">
              <h3 className="pb-1">Rewards Levels</h3>
              <p>The more you earn, the more you enjoy!</p>
            </div>
            <ul>
              {loyaltyLevels.map((item, key) => {
                return (
                  <li
                    key={key}
                    className={`${isActive(key) ? "active" : ""} ${
                      isCurrent(key) ? "current" : ""
                    }`}
                  >
                    <abbr>Level {key + 1}</abbr>
                    <h5 className="mb-1 fs-6">{item.points} Points</h5>
                    <h5>Get {getBenefitType(item)}</h5>
                    <span>
                      <CheckCircleFill
                        size={22}
                        className={
                          isActive(key)
                            ? "step-icon-active"
                            : isCurrent(key)
                              ? "step-icon-current"
                              : "step-icon-inactive"
                        }
                      />
                    </span>

                    <span>
                      {" "}
                      <small className="w-auto">
                        {isActive(key)
                          ? "Unlocked"
                          : isCurrent(key)
                            ? `${item.points - Number(loyaltyPoints)} points to go`
                            : "Locked"}
                      </small>
                    </span>
                  </li>
                );
              })}
            </ul>
          </CardBody>
        </Card>
      </div>
    </>
  );
};

export default LoyaltyLevelCard;
